import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/store";
import Vuebar from "vuebar";
import "./plugins/base";
import VueSkycons from "vue-skycons";
import InstantSearch from "vue-instantsearch";
import firebase from 'firebase/app'
import 'firebase/firestore';

const config_VSCFarm = {
  apiKey: 'AIzaSyBGpt1Gh70EjnHVPYR5YqihELCZqobBEH0', //YOUR_PROJECT_API_KEY
  authDomain: 'vscfarm-d7885.firebaseapp.com',
  databaseURL: 'https://vscfarm-d7885.firebaseio.com',
  projectId: 'vscfarm-d7885', //YOUR_PROJECT_ID
  storageBucket: 'vscfarm-d7885.appspot.com',
  messagingSenderId: '547204642141' //YOUR_SENDER_ID
};
firebase.initializeApp(config_VSCFarm)
export const db = firebase.firestore();
export const storage = firebase.storage().ref();

const config_skmfarm = {
  apiKey: 'AIzaSyCxrOk03GstwCDpxmoWqi9ApWvSs2gMBOc',
  authDomain: 'skmfarm-cc5cc.firebaseapp.com',
  databaseURL: 'https://skmfarm-cc5cc.firebaseio.com',
  projectId: 'skmfarm-cc5cc',
  storageBucket: 'skmfarm-cc5cc.appspot.com',
  messagingSenderId: '1034285450280'
};
var otherProject = firebase.initializeApp(config_skmfarm, 'secondary');
export const dbSensor = otherProject.firestore();

/*import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    // key: "AIzaSyDKCy2-UoJiEGGgOtMgM3kQvBrsYmxnyoU", //VSCFarm
    // key: "AIzaSyAuWrnXZqPJV53cJ2Nr6huMjGE-lN4OCfk",  // doublespace
    key: "AIzaSyDXLupRUuaJXsfbOUXiLn3dXRe0ugf50AM",  // merliniumiot
  },
});
*/
Vue.use(VueSkycons, {
  color: "#1e88e5",
});
Vue.use(InstantSearch);
Vue.config.productionTip = false;
Vue.use(Vuebar);

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
